import React from 'react';

import { alpha } from '@mui/material/styles';

import PlaySmallIcon from '../../assets/icons/PlaySmallIcon';
import Modal, { Modals } from '../../modals/Modal';
import styled from '../../styled';
import { BREAKPOINTS_VALUES, colorsPalette } from '../../theme';
import { LazyLoadImage } from '../LazyloadImage';
import { VideoInterface } from './Video';

const PortraitVideo: React.FC<VideoInterface> = ({
  id,
  title,
  userName,
  previewUrl,
  background,
  handleClick,
  durationNumb,
  verseId,
  bumperUrl,
  shouldOpenInModal = false,
}) => {
  return (
    <Modal
      verseId={verseId}
      duration={durationNumb}
      title={title}
      expertName={userName}
      bumperUrl={bumperUrl}
    >
      {({ openModal }) => (
        <VideoWrap
          onClick={() => {
            if (shouldOpenInModal) {
              openModal(Modals.VideoModal);
              return;
            }

            if (handleClick) {
              handleClick(id);
            }
          }}
          background={background}
        >
          <StyledLazyLoadImage
            className={'videoImg'}
            path={previewUrl}
            alt={title}
            draggable={false}
            srcset={[{ width: 230 }, { width: 270 }, { width: 280 }, { width: 300 }]}
            sizes={`(max-width:${BREAKPOINTS_VALUES['sm']}px) 230px, (max-width: ${BREAKPOINTS_VALUES['md']}) 270px, (max-width:${BREAKPOINTS_VALUES['lg']}px) 280px, 300px`}
          />
          <BtnWrap>
            <Btn color={colorsPalette.white} />
          </BtnWrap>
          <Title title={title}>{title}</Title>
        </VideoWrap>
      )}
    </Modal>
  );
};

export default PortraitVideo;

const VideoWrap = styled('div', {
  shouldForwardProp: (prop) => prop !== 'background',
})`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  height: 225px;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  background: ${({ background, theme }) =>
    background === 'Dark' ? theme.palette.secondary.main : theme.palette.secondary.dark};

  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 90%;
    background: ${({ background }) =>
      background === 'Dark'
        ? `linear-gradient(0deg, ${alpha(colorsPalette.blackSecondary, 1)} 0%, ${alpha(
            colorsPalette.violetDark,
            0.9,
          )} 17%, ${alpha(colorsPalette.violetDark, 0)} 100%) 0% 0% no-repeat`
        : `linear-gradient(0deg, ${colorsPalette.blueDark} 0%, ${alpha(
            colorsPalette.blueDark,
            0.9,
          )} 17%, ${alpha(colorsPalette.blueDark, 0)} 100%) 0% 0% no-repeat`};
    -webkit-background-origin: padding-box;
    -o-background-origin: padding-box;
    -moz-background-origin: padding-box;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    height: 315px;

    &:hover {
      & .videoImg {
        height: 110%;
      }
    }
  }
`;
const StyledLazyLoadImage = styled(LazyLoadImage)`
  position: absolute;
  right: 50%;
  bottom: 50%;
  height: 100%;
  transform: translate(50%, 50%);
  transition: height 0.3s ease;
`;
const BtnWrap = styled('div')`
  cursor: pointer;
  position: absolute;
  transform: translate(-40%, -60%);
  background: ${alpha(colorsPalette.blueDark, 0.5)};
  top: 50%;
  left: 50%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 50px;
  height: 50px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 70px;
    height: 70px;
  }
`;
const Btn = styled(PlaySmallIcon)`
  width: 24px;
  height: 28px;
  margin-left: 2px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 35px;
    height: 40px;
    margin-left: 4px;
  }
`;
const Title = styled('span')`
  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
  margin: 0 17px 17px 17px;
  z-index: 4;
  overflow: hidden;
  white-space: inherit;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  width: 75%;
  max-height: 72px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    font-size: 20px;
    line-height: 24px;
    margin: 0 23px 23px 23px;
  }
`;
